import { render, staticRenderFns } from "./SerieCard.vue?vue&type=template&id=1ebdfccc&scoped=true&"
import script from "./SerieCard.vue?vue&type=script&lang=js&"
export * from "./SerieCard.vue?vue&type=script&lang=js&"
import style0 from "./SerieCard.vue?vue&type=style&index=0&id=1ebdfccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebdfccc",
  null
  
)

component.options.__file = "SerieCard.vue"
export default component.exports